import { render, staticRenderFns } from "./CourseBuilderAudio.vue?vue&type=template&id=3129421a&scoped=true&"
import script from "./CourseBuilderAudio.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3129421a",
  null
  
)

export default component.exports